import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import CompanySchema from "../../../joi/master/company.schema";
import {
  addCompanyApi,
  updateCompanyApi,
} from "../../../services/company.service";

export default function CompanyModal({
  open,
  onClose,
  refetch,
  selectedRow = null,
}) {
  const LABEL_DATA = [
    { label: "City", name: "city" },
    { label: "Area", name: "area" },
    { label: "Contact", name: "contract" },
    { label: "Email", name: "email" },
    { label: "Fax No.", name: "faxNo" },
    { label: "Message", name: "message" },
    { label: "PinCode", name: "pincode" },
    { label: "D.L. No.", name: "dlNo" },
    { label: "Remarks", name: "remarks" },
  ];
  const initialState = {
    code: "",
    name: "",
    shortName: "",
    address: "",
    area: "",
    city: "",
    email: "",
    faxNo: "",
    pincode: "",
    dlNo: "",
    contract: "",
    message: "",
    remarks: "",
    active: true,
  };
  const [formData, setFormData] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((preValue) => ({
      ...preValue,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formData);
    let response;

    const { error } = CompanySchema.validate(formData);

    if (error) {
      error.details.forEach((err) => toast.error(err.message));
      return;
    }

    setIsLoading(true);
    const id = formData._id || selectedRow?._id;
    const { _id, ...payload } = formData;
    if (id) {
      response = await updateCompanyApi(id, payload);
    } else {
      response = await addCompanyApi(payload);
    }
    setIsLoading(false);

    if (response?.code === 200) {
      toast.success(
        response?.message ||
          `Company ${id ? "updated" : "added"} successfully`
      );
      setFormData(initialState);
      onClose();
      refetch();
    } else {
      toast.error(response?.message || "Some error occurred.");
    }
  };
  useEffect(() => {
    if (selectedRow?._id) {
      setFormData({
        ...initialState,
        _id: selectedRow._id,
        code: selectedRow?.code ?? "",
        name: selectedRow?.name || "",
        shortName: selectedRow?.shortName || "",
        address: selectedRow?.address || "",
        area: selectedRow?.area || "",
        city: selectedRow?.city || "",
        email: selectedRow?.email || "",
        faxNo: selectedRow?.faxNo || "",
        pincode: selectedRow?.pincode || "",
        dlNo: selectedRow?.dlNo || "",
        contract: selectedRow?.contract || "",
        message: selectedRow?.message || "",
        remarks: selectedRow?.remarks || "",
        active: selectedRow?.active ?? true,
      });
    } else {
      setFormData(initialState);
    }
  }, [open, selectedRow?._id]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        sx: {
          minWidth: "70vw",
          minHeight: "35vh",
          bgcolor: "#E5F4FF",
          borderRadius: "20px",
        },
      }}
    >
      <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "100%", paddingBottom: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: 2,
            }}
          >
            <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
              Add Company
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Grid container spacing={2} sx={{ paddingInline: 2, paddingTop: 2 }}>
            <Grid item xs={4}>
              <TextField
                label="Code"
                variant="outlined"
                name="code"
                value={formData?.code || ""}
                onChange={handleChange}
                fullWidth
                required
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                required
                label="Name"
                name="name"
                value={formData?.name || ""}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Short Name"
                name="shortName"
                value={formData?.shortName || ""}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ paddingInline: 2, paddingTop: 2 }}>
            <Grid item xs={8}>
              <TextField
                label="Address"
                name="address"
                value={formData?.address || ""}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="active"
                    checked={formData?.active}
                    onChange={handleChange}
                  />
                }
                label="Active"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ paddingInline: 2, paddingTop: 2 }}>
            {LABEL_DATA.slice(0, 3).map((field, index) => (
              <Grid item xs={4} key={index}>
                <TextField
                  label={field.label}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={2} sx={{ paddingInline: 2, paddingTop: 2 }}>
            {LABEL_DATA.slice(3, 6).map((field, index) => (
              <Grid item xs={4} key={index}>
                <TextField
                  label={field.label}
                  variant="outlined"
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  fullWidth
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={2} sx={{ paddingInline: 2, paddingTop: 2 }}>
            {LABEL_DATA.slice(6, 9).map((field, index) => (
              <Grid item xs={4} key={index}>
                <TextField
                  label={field.label}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
            ))}
          </Grid>

          <Box
            sx={{ display: "flex", justifyContent: "center", paddingTop: 4 }}
          >
            <Button
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} />
              ) : selectedRow?._id ? (
                "Save Changes"
              ) : (
                `Submit`
              )}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
